import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import authService from "../services/authservices";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Box, Modal } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

function Login() {
  const { login } = useContext(UserContext);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const { t } = useTranslation();

  const [errors, setErrors] = useState({});
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [signloader, setSignloader] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [otpSent, setOtpSent] = useState(true);
  const [timer, setTimer] = useState(60); // Start with 120 seconds
  const [error, setError] = useState("");
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const [verifyLoader, setverifyLoader] = useState(false);
  const [otpsectionopen, setOtpsectionopen] = useState(false);

  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

  useEffect(() => {
    var token = localStorage.getItem("token");
    if (token == null || token == "" || token == undefined) {
      // console.log(
      //   "-----------------------------------------------------------"
      // );
    } else {
      navigate("/home");
    }
  }, []);

  const sendOtp = async () => {
    try {
      setOtpSent(true);
      const response = await authService.resendOtp({
        email: user.email ? user.email : localStorage.getItem("useremail"),
      });
      if (response.data.status) {
        setTimer(60); // Start the timer at 60 seconds
        setVerificationCode("");
        showSuccessToast("OTP resent successfully!");
      } else {
        setVerificationCode("");
        showErrorToast(
          // response.data.Message || "Failed to resend OTP. Please try again."

          <div className="toast-ml">
            <h4 className="toast-title">Error!</h4>
            <p className="toast-message">
              {response.data.Message ||
                "Failed to resend OTP. Please try again."}
            </p>
          </div>
        );
        setOtpSent(false);
      }
    } catch (error) {
      setVerificationCode("");
      console.error("Error during OTP resend:", error);
      showErrorToast("An error occurred. Please try again.");
      setOtpSent(false);
    }
  };

   
  useEffect(() => {
    let countdown;
    if (timer > 0 && otpSent) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setOtpSent(false);
      clearInterval(countdown);
    }
    return () => clearInterval(countdown);
  }, [timer, otpSent]);

  const handleInputChangeNew = (e) => {
    const value = e.target.value;
    if (value.length <= 6 && /^[0-9]*$/.test(value)) {
      setVerificationCode(value);
    }
    if (error) {
      setError("");
    }
  };
  const handleKeyDownNew = (e) => {
    // Allow only numbers, Backspace, and Ctrl+V
    const allowedKeys = [
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Tab",
    ]; // Allow navigation keys and Backspace

    if (
      !/[0-9]/.test(e.key) && // Restrict non-numeric keys
      !allowedKeys.includes(e.key) && // Allow specific keys
      !(e.ctrlKey && e.key === "v") // Allow Ctrl+V for paste
    ) {
      e.preventDefault();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    let newErrors = { ...errors };
    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value) newErrors.email = "Email is required";
      else if (!emailRegex.test(value))
        newErrors.email = "Invalid email format";
      else delete newErrors.email;
    } else if (name === "password") {
      const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{12,30}$/;

      if (!value) {
        newErrors.password = "Password is required";
      } 
      // else if (value.length < 12 || value.length > 30) {
      //   // } else if (!passwordRegex.test(value)) {
      //   newErrors.password = "Invalid password format";
      // } 
      else {
        delete newErrors.password;
      }
    }

    setErrors(newErrors);
  };

  const handleKeyDown = (e, type) => {
    if (type === "email") {
      const regex = /^[a-zA-Z0-9@._-]+$/;
      if (
        !regex.test(e.key) ||
        (e.target.value.length >= 250 && e.key !== "Backspace")
      ) {
        e.preventDefault();
      }
    } else if (type === "password") {
      if (
        e.key === " " ||
        (e.target.value.length >= 30 && e.key !== "Backspace")
      ) {
        e.preventDefault();
      }
    }
  };

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  console.log(i18nextLng, "i18nextLng123");
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  useEffect(() => {
    if (theme === "dark") {
      document.body.classList.add("dark");
      document.body.classList.remove("light");
    } else {
      document.body.classList.add("light");
      document.body.classList.remove("dark");
    }

    localStorage.setItem("theme", theme);
  }, [theme]);

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{12,30}$/;

    if (!formData.password) {
      newErrors.password = "Password is required";
    } 
    // else if (formData.password.length < 12 || formData.password.length > 30) {
    //   // else if (!passwordRegex.test(formData.password)) {
    //   newErrors.password = "Invalid password format";
    // }

    return newErrors;
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setTimer(0);
    setOpen(false);
  };
  const handleCloseOtp = () => setOtpsectionopen(false);

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };
  const handleSubmitNew = async (e) => {
    const value = e.target.value;
    e.preventDefault();
    if (!verificationCode) {
      setError("OTP is required");
      return;
    }
    if (/^\d*$/.test(value)) {
      setVerificationCode(value);
      if (error) {
        setError("");
      }
    }
    try {
      setSignloader(true);
      const response = await authService.verifyOtp({
        email: user.email ? user.email : localStorage.getItem("useremail"),
        emailOtp: Number(verificationCode),
      });
      setSignloader(false);
      if (response.status) {
        showSuccessToast("OTP verified successfully ! Login to continue");
        setOtpsectionopen(false);
      } else {
        showErrorToast(response.Message);
        // setOtpsectionopen(true)
      }
    } catch (error) {
      setSignloader(false);
      console.error("Error during OTP verification:", error);
      setError("An error occurred. Please try again.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      const firstErrorField = Object.keys(validationErrors)[0];
      const firstErrorElement = document.getElementsByName(firstErrorField)[0];
      if (firstErrorElement) {
        firstErrorElement.focus();
      }
      return;
    }

    try {
      setSignloader(true);
      localStorage.setItem("useremail", formData.email);
      const loginResponse = await authService.login(formData);
      // console.log("Login response:", loginResponse);

      if (loginResponse.status) {
        if (loginResponse.requires2FA) {
          // toast.info("2FA required. Redirecting to 2FA login page.");
          navigate("/tfa");
          setSignloader(false);
        } else {
          // localStorage.setItem('token', loginResponse.token);
          const token = loginResponse.token;
          await login(token);
          const userDetails = await authService.getUserDetails();
          if (userDetails.status) {
            const maskedPassword =
              formData.password.charAt(0) +
              "*".repeat(formData.password.length - 1);
            localStorage.setItem("maskedPassword", maskedPassword);
          } else {
            showErrorToast("Failed to fetch user details after login.");
          }
          showSuccessToast("Login successful!");
          navigate("/home");
          setSignloader(false);
        }
      } else {
        if (
          loginResponse.Message ==
          "Your account is not activated. Please verify to continue"
        ) {
          handleOpen();
          setSignloader(false);
        } else {
          setSignloader(false);
          showErrorToast(loginResponse.Message);
        }
      }
    } catch (error) {
      setSignloader(false);
      console.error("Error during login:", error);
      showErrorToast("An error occurred during login. Please try again.");
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  // const handleToast = () => {
  //   toast.info(
  //     <div className="toast-ml">
  //       <h4 className="toast-title">Success!</h4>
  //       <p className="toast-message">Toast message</p>
  //     </div>
  //   );
  // };

  const verify_email = async () => {
    try {
      // var obj = {
      //   email: localStorage.getItem("useremail"),
      // };
      setverifyLoader(true);
      const data = await authService.resendOtp({
        email: localStorage.getItem("useremail"),
      });
      setverifyLoader(false);
      if (data.status) {
        setTimer(60);
        // (data.Message);
        showSuccessToast("OTP sent to your email!");
        // navigate("/verification",{status:true});
        // navigate("/verification");
        setOpen(false);
        setOtpsectionopen(true);
      } else {
        // (data.Message);
        showErrorToast("Please try again later");
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="container-fluid">
        <Link to="/">
          <img
            src={require("../assests/Logo.webp")}
            alt="Logo"
            className="cursor-pointer bn-login-logo"
          />
        </Link>

        <div className="row bn-login-row mx-0 g-4">
          <div className="col-lg-6">
            <div className="d-flex flex-column mb-5">
              <div className="register_left_main mt-3">
                <div className="hero_center">
                  <div className="register_form">
                    <span className="register_head_sign">{t("Login")}</span>
                    <div className="register_inner_main">
                      <div className="getting_card_content w-100">
                        <div className="register_inner_submain w-100">
                          <div className="reg_inner_small">
                            <span className="register_spans">
                              {t("EmailAddress")}{" "}
                            </span>
                            <input
                              type="text"
                              name="email"
                              placeholder={t("EnterTheEmailAddress")}
                              className="reg_input"
                              value={formData.email}
                              onChange={handleInputChange}
                              onKeyDown={(e) => handleKeyDown(e, "email")}
                            />
                            {errors.email && (
                              <span className="error">{errors.email}</span>
                            )}
                            {/* <p className="errorcss mb-0">Invalid Email</p> */}
                          </div>
                          <div className="reg_inner_small">
                            <span className="register_spans">
                              {t("Password")}
                            </span>
                            <div className="reg_pos_rel">
                              <input
                                type={passwordVisible ? "text" : "password"}
                                name="password"
                                placeholder={t("EnterThePassword")}
                                className="reg_input"
                                value={formData.password}
                                onChange={handleInputChange}
                                onKeyDown={(e) => handleKeyDown(e, "password")}
                              />
                              <i
                                className={`fa-regular ${
                                  passwordVisible ? "fa-eye" : "fa-eye-slash"
                                } reg_eye`}
                                onClick={togglePasswordVisibility}
                              />
                            </div>
                            {errors.password && (
                              <span className="error">{errors.password}</span>
                            )}
                          </div>
                        </div>

                        <span className="reg_check_span fnt-13">
                          <Link to="/forgot"> {t("ForgetPassword")}?</Link>
                        </span>
                      </div>
                      <div className="getting_card_content">
                        {signloader === true ? (
                          <div className="reg_btn">
                            <span className="hero_invest">
                              {" "}
                              {t("Loading")}{" "}
                            </span>
                          </div>
                        ) : (
                          <div className="reg_btn" onClick={handleSubmit}>
                            <span className="hero_invest"> {t("LogIn")} </span>
                          </div>
                          // <div className="reg_btn" onClick={handleToast}>
                          //   <span className="hero_invest"> Log In </span>
                          // </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <span className="reg_bottom_span">
                    {t("DonHaveanAccount")}
                    <Link to="/register">
                      {" "}
                      <span className="reg_check_span">
                        {t("SignUp")}.
                      </span>{" "}
                    </Link>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 ">
            <div className="bn-login-right">
              <h6 className="bn-log-rgt-title">{t("LogInTradeSmarter")}</h6>
              <p className="bn-log-rgt-content">{t("WelcomeBack")}</p>
            </div>
          </div>

          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="email-popup-modal-title"
            aria-describedby="email-popup-modal-description"
          >
            <Box>
              <div className="email-popup-card">
                <div className="email-pop-icon">
                  <i
                    class="fa-regular fa-circle-xmark"
                    onClick={handleClose}
                  ></i>
                </div>
                <div className="email-pop-img mb-3">
                  <img
                    src={require("../assests/binargemail.png")}
                    alt="email-icon"
                  />
                </div>
                <h3>{t("E-mailVerificationRequire")}</h3>
                <p>{t("PleaseVerifyYourEmail")}</p>
                <div className="Submit">
                  {verifyLoader == false ? (
                    <div className="reg_btn" onClick={verify_email}>
                      <span className="hero_invest"> {t("VerifyNow")} </span>
                    </div>
                  ) : (
                    <div className="reg_btn">
                      <span className="hero_invest"> {t("Loading")} </span>
                    </div>
                  )}
                </div>
              </div>
            </Box>
          </Modal>
          <Modal
            open={otpsectionopen}
            onClose={handleCloseOtp}
            aria-labelledby="email-popup-modal-title"
            aria-describedby="email-popup-modal-description"
          >
            <Box>
              <Box>
                <div className="email-popup-card">
                  <div className="email-pop-icon">
                    <i
                      class="fa-regular fa-circle-xmark"
                      onClick={handleCloseOtp}
                    ></i>
                  </div>
                  <div className="email-pop-img mb-3">
                    <img
                      src={require("../assests/binargemail.png")}
                      alt="email-icon"
                    />
                  </div>
                  <h3>{t("EmailVerify")}</h3>
                  <div className="register_inner_submain w-100">
                    <div className="reg_inner_small">
                      <span className="register_spans">{t("EmailCode")}</span>
                      <div className="reg_pos_rel">
                        <input
                          type="number"
                          name="emailOtp"
                          placeholder={t("EnterTheVerificationCode")}
                          className="reg_input email_padding_resp"
                          value={verificationCode}
                          onChange={handleInputChangeNew}
                          onKeyDown={handleKeyDownNew}
                        />
                        {otpSent ? (
                          <span className="pos_abs_resend">
                            {t("Resend")} ({timer}s)
                          </span>
                        ) : (
                          <span
                            className="pos_abs_resend"
                            onClick={sendOtp}
                            style={{ cursor: "pointer" }}
                          >
                            {t("Resend")}
                          </span>
                        )}
                      </div>

                      {error && <span className="error">{error}</span>}
                    </div>
                  </div>
                  <div
                    className="getting_card_content"
                    style={{ marginTop: "20px" }}
                  >
                    {signloader === true ? (
                      <div className="reg_btn">
                        <span className="hero_invest"> {t("Loading")} </span>
                      </div>
                    ) : (
                      <div className="reg_btn" onClick={handleSubmitNew}>
                        <span className="hero_invest"> {t("Verify")} </span>
                      </div>
                    )}
                  </div>
                </div>
              </Box>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default Login;
